import product from './product'
import core from './core'


const server = {
  product,
  core,
}

export default server;